import { useEffect } from 'react';

const useScrollToTop = (trigger = true) => {
  useEffect(() => {
    if (trigger) {
      // Scroll to top smoothly
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }, [trigger]);
};

export default useScrollToTop;
